import { useCallback, useMemo, useState } from "react";

import { MAX_SELECTABLE_SERIES } from "~/feature/chart/constants";
import { buildMarketGroups } from "~/feature/chart/utils";
import type { IMarket } from "~/types/event";

import {
  buildDropdownGroups,
  type IMarketDropdownGroup,
} from "./buildDropdownGroups";

interface IUseMarketDropdownMenuParams {
  markets: IMarket[];
  selections: string[];
  onToggle: (marketId: string) => void;
}

export const useMarketDropdownMenu = ({
  markets,
  selections,
  onToggle,
}: IUseMarketDropdownMenuParams) => {
  const [expandedGroupId, setExpandedGroupId] = useState<string | null>(null);

  const marketGroups = useMemo(() => buildMarketGroups(markets), [markets]);
  const groups = useMemo(
    () => buildDropdownGroups(marketGroups, selections, expandedGroupId),
    [expandedGroupId, marketGroups, selections]
  );
  const isMaxSelected = selections.length >= MAX_SELECTABLE_SERIES;

  const handleGroupClick = useCallback(
    ({ id, isExpandable, markets: groupMarkets }: IMarketDropdownGroup) => {
      if (isExpandable) {
        setExpandedGroupId((previousId) => (previousId === id ? null : id));

        return;
      }

      onToggle(groupMarkets[0].id);
    },
    [onToggle]
  );

  return { groups, isMaxSelected, handleGroupClick };
};
